import React from "react"
import { concatStrings } from "../utilities"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbParagraph from "../ui-kit/dfb_paragraph"

const CDfbnetConnection = ({ email, dfbnetId, add_class }) => {
  const list = [
    {
      name: "MEIN.DFB",
      label: "MEIN.DFB E-Mail Kennung",
      value: email,
    },
    {
      name: "DFBnet",
      label: "DFBnet Kennung",
      value: dfbnetId,
    },
  ]

  return (
    <div className={concatStrings("c-DfbnetConnection", add_class)}>
      <ul className="c-DfbnetConnection-list">
        {list.map(item => (
          <li className="c-DfbnetConnection-item" key={item.name}>
            <div className="c-DfbnetConnection-image">
              <img className="dfb-Logo-logo" src={`${process.env.EXT_ASSET_HOST}assets/images/dfb-logo.svg`} alt="DFB Logo" />
              <DfbHeadline headline={item.name} headline_level="h6" />
            </div>
            <div className="c-DfbnetConnection-text">
              <DfbHeadline headline={item.label} headline_level="h5" />
              <DfbParagraph text={item.value} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default CDfbnetConnection
